import { Marker } from "react-leaflet";
import { DefaultIcon } from "./DefaultIcon";

export const MapMarker = ({ position, icon }) => {
    return position ? <Marker position={[position.lat, position.lng]} icon={icon ?? DefaultIcon} /> : null;
};